module.exports = __webpack_public_path__ + "static/media/pac.b5ad7ba7.png";